// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hA-z","response":"iA-z","error":"jA-z","disabled":"kA-z","buttons":"lA-z","feedbackQuestionSection":"mA-z","yesNoWrapper":"nA-z"};